import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { accountingCategoryService } from "~/services/contabilidad/accountingCategoryService";

import type {
  AccountingCategoryFilters,
  AccountingCategoryFormData,
} from "~/types/contabilidad";

export const ACCOUNTING_CATEGORIES_QUERY_KEY = ["accountingCategories"];

export function useAccountingCategories(filters?: AccountingCategoryFilters) {
  return useQuery({
    queryKey: [...ACCOUNTING_CATEGORIES_QUERY_KEY, filters],
    queryFn: () => accountingCategoryService.getAll(filters),
  });
}

export function useCreateAccountingCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: AccountingCategoryFormData) =>
      accountingCategoryService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACCOUNTING_CATEGORIES_QUERY_KEY,
      });
      toast.success("Categoría creada exitosamente");
    },
    onError: (error: Error) =>
      toast.error(`Error al crear categoría: ${error.message}`),
  });
}

export function useUpdateAccountingCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: Partial<AccountingCategoryFormData>;
    }) => accountingCategoryService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACCOUNTING_CATEGORIES_QUERY_KEY,
      });
      toast.success("Categoría actualizada exitosamente");
    },
    onError: (error: Error) =>
      toast.error(`Error al actualizar categoría: ${error.message}`),
  });
}

export function useDeleteAccountingCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => accountingCategoryService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACCOUNTING_CATEGORIES_QUERY_KEY,
      });
      toast.success("Categoría eliminada exitosamente");
    },
    onError: (error: Error) =>
      toast.error(`Error al eliminar categoría: ${error.message}`),
  });
}
